/**
 * Identificador estable del dispositivo/navegador.
 *
 * Se envía en el header X-Device-Id en cada request para poder medir el uso
 * real de licencias: distinguir una persona con varios dispositivos (uso
 * legítimo) de una credencial compartida entre varias personas.
 *
 * No pretende ser infalsificable, y no necesita serlo: borrarlo para evadir la
 * medición genera MÁS dispositivos distintos, no menos — la evasión empeora la
 * propia métrica de quien la intenta.
 *
 * Es por navegador, no por usuario: en los talleres las tablets se comparten
 * entre mecánicos y cada uno entra con su credencial, así que el mismo
 * device_id asociado a varios usuarios es una situación normal y esperada.
 */

const DEVICE_ID_KEY = 'fcDeviceId';
export const DEVICE_ID_HEADER = 'X-Device-Id';

function generarId() {
  // crypto.randomUUID no existe en navegadores viejos ni en contextos no
  // seguros (http://ip:3000 en la red del taller): de ahí el fallback.
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID().replace(/-/g, '');
    }
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
      const buffer = new Uint8Array(16);
      crypto.getRandomValues(buffer);
      return Array.from(buffer, (b) => b.toString(16).padStart(2, '0')).join('');
    }
  } catch {
    // Cae al fallback de abajo.
  }
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
}

/**
 * Devuelve el identificador del dispositivo, creándolo la primera vez.
 * Si localStorage no está disponible (modo privado, storage bloqueado) se
 * devuelve un id efímero en memoria para no romper el login.
 */
let idEnMemoria = null;

export function getDeviceId() {
  try {
    const guardado = localStorage.getItem(DEVICE_ID_KEY);
    if (guardado) {
      return guardado;
    }
    const nuevo = generarId();
    localStorage.setItem(DEVICE_ID_KEY, nuevo);
    return nuevo;
  } catch {
    if (!idEnMemoria) {
      idEnMemoria = generarId();
    }
    return idEnMemoria;
  }
}

export default getDeviceId;
